<template>
	<!-- TODO: search -->
	<!-- TODO: header with button for adding new statuses -->
	<!-- TODO: edit dialog -->
	<v-sheet rounded class="mb-4">
		<v-card color="#125B92" elevation="0" class="rounded-b-0">
			<v-card-title class="align-center">
				<h3 class="white--text">{{ modelName |capitalize }} Statuses</h3>
				<v-spacer />
				<v-btn
					rounded
					color="success"
					elevation="0"
					class="font-weight-bold"
					@click="createStatus">
					<v-icon left>mdi-plus-circle</v-icon>
					New {{ modelName |capitalize }} Status
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="white pa-0">
				<v-data-table
					:loading="loading"
					:headers="tableHeaders"
					:items="statuses"
					:sort-by="sortBy"
					:sort-desc="sortDesc"
					:search="search"
					:items-per-page="999"
					hide-default-footer
					class="table-stripped">
					<template #top>
						<v-toolbar flat>
							<v-spacer />
							<div class="flex-fill datatable-filter-large">
								<v-text-field
									v-model.trim="search"
									class="table-search"
									append-icon="mdi-magnify"
									placeholder="Search..."
									name="search"
									autocomplete="off"
									single-line
									clearable
									filled
									dense
									outlined
									full-width
									autofocus
									hide-details />
							</div>
							<div class="ml-3">
								<v-chip>{{ length(statuses) | numeric }}</v-chip>
							</div>
						</v-toolbar>
					</template>

					<template #item.color="{ item }">
						<v-chip v-if="item.color" :color="item.color" :dark="isDarkColor(item.color)">{{ item.color }}</v-chip>
						<em v-else class="grey--text lighten-1">None</em>
					</template>

					<template #item.is_locked="{ item }">
						<v-icon v-if="item.is_locked" color="success">mdi-check-circle-outline</v-icon>
						<v-icon v-else color="grey lighten-1">mdi-close-circle-outline</v-icon>
					</template>

					<template #item.is_starting="{ item }">
						<v-icon v-if="item.is_starting" color="success">mdi-check-circle-outline</v-icon>
						<v-icon v-else color="grey lighten-1">mdi-close-circle-outline</v-icon>
					</template>

					<template #item.is_ending="{ item }">
						<v-icon v-if="item.is_ending" color="success">mdi-check-circle-outline</v-icon>
						<v-icon v-else color="grey lighten-1">mdi-close-circle-outline</v-icon>
					</template>

					<template #item.actions="{ item }">
						<v-btn icon class="mr-1" @click="editStatus(item)">
							<v-icon color="secondary">mdi-pencil</v-icon>
						</v-btn>
						<delete-button icon :model="dataModel" :model-id="item.id">
							<v-icon color="danger">
								mdi-delete
							</v-icon>
						</delete-button>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>

		<v-dialog v-model="statusDialog" transition="scroll-x-reverse-transition" max-width="600px">
			<template #default>
				<v-form @submit.prevent="handleForm">
					<v-card>
						<v-card-title>
							<div v-if="editing">Editing {{ editing.name }} - {{ modelName |capitalize }} Status</div>
							<div v-else>Create New {{ modelName |capitalize }} Status</div>
							<v-icon right class="ml-auto theme--dark" @click="statusDialog = false">mdi-close</v-icon>
						</v-card-title>
						<v-divider class="mb-2" />
						<v-card-text>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.name"
										label="Status Name"
										name="name"
										:hide-details="! hasErrors(form, 'name')"
										:error="hasErrors(form, 'name')"
										:error-messages="errorMsg(form, 'name')"
										outlined
										autofocus
										required
										dense />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-card outlined>
										<v-card-text>
											<v-checkbox
												v-model="form.is_starting"
												class="mt-0 pt-0"
												label="Start Status?"
												name="is_starting"
												:hide-details="! hasErrors(form, 'is_starting')"
												:error="hasErrors(form, 'is_starting')"
												:error-messages="errorMsg(form, 'is_starting')"
												outlined
												required
												dense />
										</v-card-text>
									</v-card>
								</v-col>
								<v-col>
									<v-card outlined>
										<v-card-text>
											<v-checkbox
												v-model="form.is_ending"
												class="mt-0 pt-0"
												label="End Status?"
												name="is_ending"
												:hide-details="! hasErrors(form, 'is_ending')"
												:error="hasErrors(form, 'is_ending')"
												:error-messages="errorMsg(form, 'is_ending')"
												outlined
												required
												dense />
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select
										v-model="form.color"
										:items="selectColors"
										placeholder="Color"
										clearable
										outlined
										hide-details
										dense>
										<template #selection="{ item }">
											<v-chip :color="item.value" :dark="isDarkColor(item.value)">{{ item.value | capitalize }}</v-chip>
										</template>
										<template #item="{ item }">
											<v-chip :color="item.value" :dark="isDarkColor(item.value)">{{ item.value | capitalize }}</v-chip>
										</template>
									</v-select>
								</v-col>
							</v-row>
						</v-card-text>
						<v-divider />
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="warning darken-1"
								text
								:disabled="form.processing"
								@click="statusDialog = false">
								Cancel
							</v-btn>
							<v-btn type="submit" large color="success" :loading="form.processing">Update Status</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</template>
		</v-dialog>
	</v-sheet>
</template>
<script>
import DeleteButton from '@/Pages/Backend/Components/DeleteButton'
import api from '@/api'
import colors from 'vuetify/lib/util/colors'


export default {
	components: {
		DeleteButton
	},
	props: {
		modelName: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			loading: true,
			statuses: [],
			sortBy: 'name',
			sortDesc: false,
			search: '',
			tableHeaders: [
				{
					text: 'Name',
					align: 'start',
					value: 'name'
				},
				{
					text: 'Locked',
					align: 'center',
					value: 'is_locked'
				},
				{
					text: 'Start Status',
					align: 'center',
					value: 'is_starting'
				},
				{
					text: 'End Status',
					align: 'center',
					value: 'is_ending'
				},
				{
					text: 'Color',
					align: 'center',
					value: 'color'
				},
				{
					text: '',
					align: 'end',
					value: 'actions'
				}
			],
			editing: false,
			statusDialog: false,
			colors: colors,
			form: this.$inertia.form({
				name: null,
				is_starting: null,
				is_ending: null,
				color: null
			})
		}
	},
	computed: {
		dataModel () {
			return this.modelName + '-statuses'
		},
		selectColors () {
			let colors = []

			for (const colorsKey in this.colors) {
				if (! this.colors.hasOwnProperty(colorsKey)) continue
				if (! this.colors[colorsKey].hasOwnProperty('base')) continue

				let kebabColorKey = colorsKey
					.split(/(?=[A-Z])/)
					.map(word => word.toLowerCase())
					.join('-')

				colors.push({
					value: kebabColorKey,
					text: kebabColorKey
				})

				for (const colorAltKey in this.colors[colorsKey]) {
					if (! this.colors[colorsKey].hasOwnProperty(colorAltKey)) continue
					if (colorAltKey === 'base') continue
					let formattedKey = colorAltKey

					formattedKey = formattedKey.replace('lighten', 'lighten-')
					formattedKey = formattedKey.replace('darken', 'darken-')
					formattedKey = formattedKey.replace('accent', 'accent-')

					colors.push({
						value: kebabColorKey + ' ' + formattedKey,
						text: kebabColorKey + ' ' + formattedKey
					})
				}
			}

			return colors
		}
	},
	mounted () {
		this.getStatuses()
	},
	methods: {
		getStatuses () {
			this.loading = true
			const method = 'GET'
			const data = {}

			const url = this.route(this.dataModel + '.api.index')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.statuses = response.data
			}).finally(() => this.loading = false)
		},

		createStatus () {
			this.form.reset()
			this.statusDialog = true
		},

		editStatus (status) {
			this.statusDialog = true
			this.editing = status

			for (const reportKey in status) {
				if (!status.hasOwnProperty(reportKey)) continue

				if (this.form.hasOwnProperty(reportKey)) {
					this.form[reportKey] = status[reportKey]
				}
			}
		},

		handleForm () {
			if (this.editing) {
				// Edit
				this.form.put(this.route(this.dataModel + '.update', this.editing), {
					onSuccess: () => {
						this.statusDialog = false

						setTimeout(() => {
							this.editing = false
							this.form.reset()
						}, 250)
					},
					onFinish: () => this.getStatuses()
				})
			} else {
				// Create
				this.form.post(this.route(this.dataModel + '.store', this.editing), {
					onSuccess: () => {
						this.statusDialog = false

						setTimeout(() => {
							this.editing = false
							this.form.reset()
						}, 250)
					},
					onFinish: () => this.getStatuses()
				})
			}
		}
	}
}
</script>
